import * as React from "react";
import { useState, useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { MenuItem, TextField } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useParams, useSearchParams } from "react-router-dom";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import arrow from "../../../../styles/svg/arrow.svg";
import Field from "../../../../components/field";
import { useResponsive } from "../../../../hooks/useResponsive";
import { mergeMilestone } from "../../../../sevices/apiEpic";
import Loader from "../../../../components/Loader";
import useToastPromise from "../../../../hooks/useToast";
import CustomMenuItem from "../../../../components/Menu/CustomMenuItem";
import FormDialog from "../../../../components/Dialog/FormDialog";
import { RFHTextField, RHFSelect } from "../../../../components/RFH";
import useBoardIdByKey from "../../../../hooks/useBoardIdByKey";

export default function MergeMilestonePopUp({
  open,
  close,
  unlockedMilestone,
  isSelectSourceMilestone,
  SelectedSourceMileStone,
}) {
  const queryClient = useQueryClient();
  const isMobile = useResponsive("down", "md");
  const [searchParams, setSearchParams] = useSearchParams();
  const [currentMilestone, setCurrentMilestone] = useState(null);
  const [unloakedmilestone, setUnloakedMilestone] = useState([]);
  const [selectedTargetMilestone, setSelectedTargetMilestone] = useState(null);
  const { showToastPromise } = useToastPromise();

  const { id } = useBoardIdByKey();
  const [isloading, setIsLoading] = React.useState(false);
  const {
    register,
    handleSubmit: updateBoardSubmit,
    formState: { },
    getValues,
    ...methods
  } = useForm({
    targetStep: "None",
  });

  useEffect(() => {
    if (unlockedMilestone) {
      setUnloakedMilestone(unlockedMilestone);
    }
  }, [unlockedMilestone]);

  const epicDetail = SelectedSourceMileStone?.data?.data?.responseData?.epic;

  const { mutate, isPending } = useMutation({
    mutationFn: async (data) => {
      return await showToastPromise(mergeMilestone, data);
    },
    onSuccess: (res) => {
      queryClient.invalidateQueries({
        queryKey: [`cards`, id],
      });
      queryClient.invalidateQueries({
        queryKey: [`epic`, id],
      });
      searchParams.set("milestone", selectedTargetMilestone);
      setSearchParams(searchParams);
      close(false);
      //toast.success(res.data.message);
      setIsLoading(false);
    },
    onError: (error) => {
      console.error("Error Delete Attachments", error);
    },
  });

  useEffect(() => {
    if (SelectedSourceMileStone) {
      setCurrentMilestone(epicDetail?.epic_id);
    }
  }, [SelectedSourceMileStone]);

  const targetMilestone =
    unloakedmilestone?.filter((item) => item.epic_id !== currentMilestone) ||
    [];

  const sourceMilestone =
    unloakedmilestone?.filter(
      (item) => item.epic_id !== selectedTargetMilestone
    ) || [];

  const onSubmit = (data) => {
    setIsLoading(true);
    if (isSelectSourceMilestone) {
      data = {
        currentMilestone: epicDetail?.epic_id,
        targetMilestone: data?.targetMilestone,
      };
      mutate(data);
    } else {
      mutate(data);
    }
  };

  const handleClose = () => {
    close(false);
  };
  return (
    <>
      <FormProvider {...methods}>
        <FormDialog
          open={open}
          handleClose={handleClose}
          title={"Merge Milestone"}
          buttonTxt={"Merge"}
          handleSubmit={updateBoardSubmit(onSubmit)}
          disabled={
            isloading ||
            currentMilestone == null ||
            selectedTargetMilestone == null
          }
          width={494}
          fullWidth={true}>
          <div className="move-ticket-form-dialogContent">
            <div
              className={
                isMobile
                  ? "mobile-ticket-reasign-step-container"
                  : "ticket-reasign-step-container"
              }>
              <div
                className={
                  isMobile
                    ? "mobile-current-target-board-name"
                    : "current-target-board-name"
                }>
                <p> Source Milestone </p>
                {isSelectSourceMilestone ? (
                  <div className="initial-step">
                    <RFHTextField
                      name=""
                      className="mui-status-field"
                      disabled
                      value={epicDetail?.epic_name}
                    />
                  </div>
                ) : (
                  <div className="initial-step">
                    <RHFSelect
                      name="currentMilestone"
                      sx={{
                        width: isMobile ? "100%" : "180px",
                      }}
                      className="mui-status-field"
                      required
                    // value={getValues(`currentMilestone`)}
                    >
                      {sourceMilestone.length > 0 ? (
                        sourceMilestone?.map((option) => (
                          <CustomMenuItem
                            key={option.epic_id}
                            id={option.epic_id}
                            value={option.epic_id}
                            onClick={() => setCurrentMilestone(option.epic_id)}>
                            {option.epic_name}
                          </CustomMenuItem>
                        ))
                      ) : (
                        <CustomMenuItem>No Milestone</CustomMenuItem>
                      )}
                    </RHFSelect>
                  </div>
                )}
              </div>

              <img src={arrow} alt="" />
              <div
                className={
                  isMobile
                    ? "mobile-current-target-board-name"
                    : "current-target-board-name"
                }>
                <p>Target Milestone</p>
                <div className="initial-step">
                  <RHFSelect
                    name="targetMilestone"
                    sx={{
                      width: isMobile ? "100%" : "180px",
                    }}
                    className="mui-status-field"
                    required
                  // value={getValues(`targetMilestone`)}
                  >
                    {targetMilestone.length > 0 ? (
                      targetMilestone?.map((option) => (
                        <CustomMenuItem
                          key={option.epic_id}
                          id={option.epic_id}
                          value={option.epic_id}
                          onClick={() =>
                            setSelectedTargetMilestone(option.epic_id)
                          }>
                          {option.epic_name}
                        </CustomMenuItem>
                      ))
                    ) : (
                      <CustomMenuItem>No Milestone</CustomMenuItem>
                    )}
                  </RHFSelect>
                </div>
              </div>
            </div>
          </div>
          {isPending && (
            <div className="popup-loader">
              <Loader color={"black"} />
            </div>
          )}
        </FormDialog>
      </FormProvider>
    </>
  );
}
